export default __webpack_public_path__ + "static/media/google-drive-logo.7b53f4c6.png";